import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Undo2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogClose, DialogDescription } from "@/components/ui/dialog";

export const RefundButton = ({ purchase, onDone }) => {
  const [open, setOpen] = useState(false);
  const [revoke, setRevoke] = useState(true);
  const [busy, setBusy] = useState(false);

  const refund = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/purchases/${purchase.id}/refund`, { revoke_access: revoke });
      toast.success(`Refunded ${purchase.email}`);
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(errMsg(e, "Refund failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="text-xs font-semibold text-mm-error flex items-center gap-1 hover:underline" data-testid={`admin-refund-${purchase.id}`}><Undo2 size={14} />Refund</button>
      </DialogTrigger>
      <DialogContent data-testid="admin-refund-dialog">
        <DialogHeader><DialogTitle>Refund {purchase.email}?</DialogTitle></DialogHeader>
        <DialogDescription className="text-sm text-mm-muted">
          The full amount ({Number(purchase.amount).toLocaleString("en-US", { style: "currency", currency: purchase.currency || "USD" })}) goes back through {purchase.provider === "paypal" ? "PayPal" : "Stripe"}. This can't be undone.
        </DialogDescription>
        <label className="flex items-center gap-3 text-sm mt-2">
          <Switch checked={revoke} onCheckedChange={setRevoke} data-testid="admin-refund-revoke-toggle" />Also remove their premium access
        </label>
        <DialogFooter className="gap-2">
          <DialogClose asChild><button className="mm-btn-ghost" data-testid="admin-refund-cancel">Cancel</button></DialogClose>
          <button className="mm-btn mm-btn-danger" onClick={refund} disabled={busy} data-testid="admin-refund-confirm">{busy && <Loader2 size={16} className="animate-spin" />}Refund</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
